import {
	CommitmentFilterType,
	OutcomeStatusV2,
	TeamType
} from "@teaming/common-enums";

export const NEW_COMMITMENT_ID = "new-commitment-id";

export function pristineNewCommitmentState( { personId, teamId, teamName, teamType, type = "ACTION_ITEM", } ) {
	return {
		assignees: [],
		assignments: [],
		completed: undefined,
		completedDateStamp: null,
		content: "",
		contentBeingEdited: "",
		created: undefined,
		createdDateStamp: undefined,
		creator: personId,
		dueDate: undefined,
		dueDateStamp: null,
		formattedCompletedDate: "",
		formattedDueDate: "",
		id: NEW_COMMITMENT_ID,
		isBeingEdited: true,
		isCompleted: false,
		isContentValid: true,
		isNewCommitment: true,
		isOverdue: false,
		matchedFilters: [
			OutcomeStatusV2.OUTSTANDING,
		],
		meetingId: undefined,
		meetingSeriesId: undefined,
		outcomeVersion: "v2",
		plannedStart: undefined,
		status: OutcomeStatusV2.OUTSTANDING,
		teamId,
		teamName,
		teamType,
		topicId: undefined,
		topicTitle: undefined,
		type,
	};
}

const pristineCommitmentPageState = () => ( {
	offset: 0,
	commitments: [],
	hasPaged: false,
	hasMorePages: true,
} );

export const pristineCommitmentPagingState = () => ( {
	metadata: {
		TOTAL: 0,
		[ CommitmentFilterType.COMPLETE ]: 0,
		[ CommitmentFilterType.DUE_IN_NEXT_WEEK ]: 0,
		[ CommitmentFilterType.NO_DUE_DATE ]: 0,
		[ CommitmentFilterType.OUTSTANDING ]: 0,
		[ CommitmentFilterType.OVERDUE ]: 0,
	},
	selectedFilterType: CommitmentFilterType.OUTSTANDING,
	commitmentPages: {
		[ CommitmentFilterType.COMPLETE ]: pristineCommitmentPageState(),
		[ CommitmentFilterType.DUE_IN_NEXT_WEEK ]: pristineCommitmentPageState(),
		[ CommitmentFilterType.NO_DUE_DATE ]: pristineCommitmentPageState(),
		[ CommitmentFilterType.OUTSTANDING ]: pristineCommitmentPageState(),
		[ CommitmentFilterType.OVERDUE ]: pristineCommitmentPageState(),
	},
	pageSize: 25,
	permitPaging: true,
	commitmentUpdatesReceived: 0,
} );

// eslint-disable-next-line no-unused-vars
export const pristineState = ( i18n, userProfile = null ) => ( {
	isSetup: false,
	team: {
		id: "",
		name: "",
		// Default team type is empty because this store also controls
		// "My Action Items", and team type is used to determine
		// which space the store is executing in for certain display
		// options.
		type: "",
		members: [ userProfile, ].filter( u => !!u ),
	},
	outcomeTypes: [],
	isFetchingMetadata: false,
	isSavingACommitment: false,
	savesInProgress: new Set(),
	commitmentIdBeingEdited: "",
	contentBeingEdited: "",
	newCommitment: null,
	...pristineCommitmentPagingState(),
} );
